// @flow
import React from 'react';

import doubleChevron from '../../../assets/images/double-chevron-left.svg';

import {
  CalendarScrollerContainer,
  ChevronImage,
} from './styled';

type Props ={
/**
 * Sets chevron direction
 * */
  direction: string,
/**
 * Sets chevron position
 * */
  position: string,
  /**
   * Function that is called when mouse is over chevron.
   * */
  onMouseEnter: { (): void },
  /**
   * Function that is called after mouse is out chevron.
   * */
  onMouseLeave: { (): void },
  /**
   * Function that is called on chevron click.
   * */
  onChevronClick: { (): void },
  /**
   * Sets fadeIn or fadeOut to chevron.
   * */
  chevronFadeOut: boolean,
};

const Scroller = ({
  direction,
  position,
  onMouseEnter,
  onMouseLeave,
  onChevronClick,
  chevronFadeOut,
}: Props) => (
  <CalendarScrollerContainer
    position={position}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    onClick={onChevronClick}
    chevronFadeOut={chevronFadeOut}
  >
    <ChevronImage
      src={doubleChevron}
      direction={direction}
    />
  </CalendarScrollerContainer>
);

export default Scroller;
